import {Chip} from "@mui/material";

export function ConnectedStatus() {
    return <Chip sx={{
        fontSize: 'small'
    }} label="Connected" color="success" />
}